import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button, Modal } from 'react-bootstrap';
import './FactTypePickerModal.css';
import FactTypePickerTable from './FactTypePickerTable.js';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import config from '../config';
import { Link } from 'react-router-dom';

class FactTypePickerModal extends Component {
    constructor(props) {
        super(props);

        this.handleHide = this.handleHide.bind(this);

        this.state = {
            show: false,
            facttypes: [],
            page: 1,
            pageCount: 0,
            limit: 10,
            search: '',
            organisationUUID: '',
            excludeAttribute: '',
            itemsSelected: []
        };
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        this.setState({ page: selected }, () => {
            this.loadOrganisationFactTypesFromServer();
        });
    };

    handleHide() {
        this.props.onHide();
        this.setState({
            itemsSelected: []
        });
    }

    handleChooseClicked() {
        this.props.onChoose(this.state.itemsSelected);
        this.setState({
            itemsSelected: []
        });
    }

    componentDidMount() {}

    loadOrganisationFactTypesFromServer() {
        var self = this;

        axios
            .get(`${config.baseURL}/facttypes`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    facttypes: response.data.factTypes,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    componentWillReceiveProps(newProps) {
        this.setState(
            {
                show: newProps.show,
                title: newProps.title,
                organisationUUID: newProps.organisationUUID,
                excludeAttribute: newProps.excludeAttribute
            },
            () => {
                this.loadOrganisationFactTypesFromServer();
            }
        );
    }

    selectionChanged(facttype, checked) {
        let itemsSelected = this.state.itemsSelected;

        if (checked) {
            itemsSelected.push(facttype.id);
        } else {
            itemsSelected = itemsSelected.filter(
                selectedItem => selectedItem !== facttype.id
            );
        }

        var selectedSet = new Set(itemsSelected);

        this.setState({
            itemsSelected: [...selectedSet]
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="FactTypePickerModal">
                <Modal
                    show={this.state.show}
                    onHide={this.handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    dialogClassName="FactTypePickerModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">
                            {t('FactTypePickerModal.title')}{' '}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ margin: '0px', padding: '0px' }}>
                        <FactTypePickerTable
                            itemsSelected={this.state.itemsSelected}
                            facttypes={this.state.facttypes}
                            onDelete={() => {}}
                            onSelectionChanged={this.selectionChanged.bind(
                                this
                            )}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="text-center">
                            <ReactPaginate
                                previousLabel={t('Pagination.previous')}
                                nextLabel={t('Pagination.next')}
                                breakLabel={<Link to="#">...</Link>}
                                breakClassName={'break-me'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                
                            />
                        </div>
                        <div className="btn-toolbar pull-right">
                            <Button onClick={this.handleHide}>
                                {t('FactTypePickerModal.close')}
                            </Button>
                            <Button
                                disabled={this.state.itemsSelected.length === 0}
                                className="btn-primary"
                                onClick={this.handleChooseClicked.bind(this)}
                            >
                                {t('FactTypePickerModal.add_selected')}
                                {` (${this.state.itemsSelected.length})`}
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default translate('translations')(FactTypePickerModal);
